
$( document ).ready(function() {

  //tmp fix for omnisend link
  if ($('h1.tt-title:contains("Sneakers")').length > 0) {

  setTimeout(() => {
    $('#shopify-section-product-template > div:nth-child(1) > div.container.container-fluid-mobile > div > div:nth-child(2) > div > div.tt-swatches-container.tt-swatches-container-js > div:nth-child(1) > ul > li > a').click();
}, 800);
  }
});

document.querySelector("#shopify-section-product-template > div:nth-child(1) > div.container.container-fluid-mobile > div > div:nth-child(2) > div > div.tt-swatches-container.tt-swatches-container-js > div:nth-child(1) > ul > li > a")


// fix for reso page


if (document.location.href.indexOf('/en/pages/modulo-reso') > -1) {
  // indexOf will return the position of the first occurence of this string in the url
  // or -1 it it's not there.
  document.location.href = 'https://www.barrowofficial.com/pages/modulo-reso';
}




function hideImagesByCollectionUrl() {
  let url = window.location.href;
  console.log(url);
  if (url.indexOf("-uomo") > -1 || url.indexOf("-man/") > -1 || url.indexOf("/man-") > -1 || url.indexOf("/man/") > -1) {
    console.log("found him");

    $('#smallGallery li:has(img[alt="woman"])').remove();
    $('.tt-mobile-product-slider div:has(img[alt="woman"])').remove();

    $('#smallGallery li:has(img[alt="Woman"])').remove();
    $('.tt-mobile-product-slider div:has(img[alt="Woman"])').remove();


  } else if (url.indexOf("-donna") > -1 || url.indexOf("-woman/") > -1 || url.indexOf("/woman-") > -1 || url.indexOf("/woman/") > -1) {
    console.log("found her");

    $('#smallGallery li:has(img[alt="man"])').remove();
    $('.tt-mobile-product-slider div:has(img[alt="man"])').remove();

    $('#smallGallery li:has(img[alt="Man"])').remove();
    $('.tt-mobile-product-slider div:has(img[alt="Man"])').remove();

    //hack to fix still life missing
    var newImage = $('#smallGallery li').eq(0).find('a').data('zoom-image');
    // $('.zoomWindow').css('background-image', 'url("' + newImage + '")');
    $('.zoom-product').attr('src', newImage);
    $('.zoom-product').attr('data-zoom-image', newImage);

    setTimeout(function () {
      $('#smallGallery li').eq(0).find('a').click();
    }, 250);


  }

}


let homePhoto = {

  'man': ['https://cdn.shopify.com/s/files/1/0551/4012/2809/files/BARROW_x_BELLEDENUIT-38_copia.jpg?v=1616765253',
    'https://cdn.shopify.com/s/files/1/0551/4012/2809/files/BARROW_x_BELLEDENUIT-12_copia.jpg?v=1616765253',
    'https://cdn.shopify.com/s/files/1/0551/4012/2809/files/BARROW_x_BELLEDENUIT-40_copia.jpg?v=1616765253'],
  'woman': ['https://cdn.shopify.com/s/files/1/0551/4012/2809/files/BARROW_x_BELLEDENUIT-43_copia.jpg?v=1616765266',
    'https://cdn.shopify.com/s/files/1/0551/4012/2809/files/BARROW_x_BELLEDENUIT-46_copia.jpg?v=1616765266',
    'https://cdn.shopify.com/s/files/1/0551/4012/2809/files/BARROW_x_BELLEDENUIT-8_copi__a.jpg?v=1616765265'],
  'capsule': ['https://cdn.shopify.com/s/files/1/0551/4012/2809/files/SferaEbbastaXBarrow_402_di_1_32a7a48f-736f-4d76-874a-31e5fffaec26.jpg?v=1616765243',
    'https://cdn.shopify.com/s/files/1/0551/4012/2809/files/SferaEbbastaXBarrow_202_di_1_5fafb3c8-a6c4-470a-a776-59e435079467.jpg?v=1616765243'],
  'accessories': ['https://cdn.shopify.com/s/files/1/0551/4012/2809/files/BARROW_x_BELLEDENUIT-_16.jpg?v=1616765220']
}

function changePhotoRandom(container, photoes) {
  var num = Math.floor(Math.random() * photoes.length);

  $(container).attr('src', photoes[num]);
}
function addComingSoon() {
  /**
  Aggiungi coming soon
  cerco tutti i sold out ai quali non ho ancora aggiungo il coming soon
  */
  $esauriti = $('.pagecollection .tt-label-location:not(.coming-soon-added) .tt-label-our-stock');
  $esauriti.each(function () {

    $label = $(this).closest('.tt-label-location');
    $label.addClass('coming-soon-added');

    $('<span class="label-coming-soon">COMING SOON</span>').insertBefore($label);
  });
}


jQuery(document).ready(function () {

  //change all url to en
  //$('a[href^="/en/"]').attr('href', (i, h) => h.replace('/en/', 'https://www.barrowofficial.shop/'));


  
  
  /** Banner lingua **/
  const userLocale =
    navigator.languages && navigator.languages.length
      ? navigator.languages[0]
      : navigator.language;

  /*if (typeof userLocale === 'string' || userLocale instanceof String) {
    if (!userLocale.startsWith('it')) {
      let $banner = $('.international-switcher');
      $banner.html('<a href="https://www.barrowofficial.shop/"><strong style="min-height:60px; display:block; line-height:60px;">Go to the English version of the site. →</strong></a>');

      $banner.show();
    }
  }
  */

  //Privacy checkbox
  $('#shopify-section-contact-template #contact_form .form-group:last').append('<label style="width:100%"><input type="checkbox" name="accept_privacy" value="1" required />Dicharo di aver letto e accettato la <a href="https://www.barrowofficial.com/policies/privacy-policy">privacy policy</a></label> ')
  $('footer #contact_form .form-group:last').append('<label style="width:100%"><input type="checkbox" name="accept_privacy" value="1" required />Dicharo di aver letto e accettato la <a href="https://www.barrowofficial.com/policies/privacy-policy">privacy policy</a></label> ')

  //addComingSoon();

  // For lazy loading

  /*$('.tt-product-listing').on('DOMNodeInserted', 'div.tt-col-item', function () {
    addComingSoon();
});*/


  // Preorder

  $addtocart = $('.pageproduct form .btn-addtocart');
  let fullSku = $('.sku-js').text();
  fullSku = $.trim(fullSku.replace("SKU:", ""));
  if ($addtocart && fullSku === '029143-110') {
    if ($addtocart.find('span:last').text() == 'PREORDERAGGIUNGI AL CARRELLO') {
      $('<div class="statusBackorder"><strong>Disponibile in PRE-ORDER:</strong> Le spedizioni di questo articolo verrà effettuata a partire dal 28 Dicembre</div>').insertBefore($addtocart.closest('.tt-row-custom-01'));
    }


    $("<style>")
      .prop("type", "text/css")
      .html("\
    .preorder-button_description{\
display: none !important;\
    }")
      .appendTo("head");

  }

  // Random photo on home

  if ($('body').hasClass('pageindex')) {

    //changePhotoRandom('.home-photo-man', homePhoto['man']);
    //changePhotoRandom('.home-photo-woman', homePhoto['woman']);
    changePhotoRandom('.home-photo-capsule', homePhoto['capsule']);
    //changePhotoRandom('home-photo-accessories', homePhoto['accessories']);
  }



  /* Sistema per nascondere le fotografie in base alla collezione dove mi trovo */

  if ($('body').hasClass('pageproduct')) {
    hideImagesByCollectionUrl();
  }


  /** Tabella taglie **/
  let sku = $('.sku-js').text();
  sku = $.trim(sku.replace("SKU:", ""));
  sku = sku.split("-")[0];
  let images = [];
  switch (sku) {

    case '029433':
    case '029434':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S.jpg?v=1616754247');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M.jpg?v=1616754247');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L.jpg?v=1616754247');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL.jpg?v=1616754247');

      break;

    case '029145':
    case '034049':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029145_XS.png?v=1678788054');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029145_S.png?v=1678788054');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029145_M.png?v=1678788054');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029145_L.png?v=1678788054');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029145_XL.png?v=1678788054');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029145_XXL.png?v=1678788054');

      break;

    case '029155':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_c89e198d-e32d-4614-a0bb-432b22ad8feb.jpg?v=1616754419');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_70465d16-28ae-4a72-9cb8-bd06933f92cf.jpg?v=1616754419');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_4a05170d-36d8-4816-98dc-6993d31dfc39.jpg?v=1616754418');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_ab8c76a4-c0c4-4edb-9d58-ddd9e4f0979d.jpg?v=1616754418');

      break;

    case '029140':
    case '029143':
    case '029281':
    case '028001':
    case '029141':
    case '029136':
    case '029133':
    case '029138':
    case '029135':
    case '029137':
    case '029139':
    case '029142':
    case '029134':
    case '028392':
    case '028393':
    case '028394':
    case '029922':
    case '029926':
    case '029927':
    case '029929':
    case '029933':
    case '029928':
    case '029931':
    case '029935':
    case '029934':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_3c84d97b-59cb-4bde-89e4-6294d46a5fa7.jpg?v=1616754805');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_5f238961-579d-4b00-8a98-fb5c6ac6f3f6.jpg?v=1616754805');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_36ce5790-0676-4560-ada1-83036621d9f0.jpg?v=1616754805');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_b6d32135-3e01-4295-986c-aa228272404f.jpg?v=1616754805');

      break;

    case '029158':
    case '028022':
    case '029574':
    case '029573':
    case '030064':
    case '031229':
    case '031176':
    case '031478':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XS.jpg?v=1616755322');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_04f035be-8523-4ec7-9846-af7ce340e79e.jpg?v=1616755322');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_7465e288-6356-46ba-9f7b-c5f80bc632e4.jpg?v=1616755322');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_48f4c824-a9e5-4779-ba71-438d076f3fc5.jpg?v=1616755322');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_4a50f772-c281-4bbc-b109-2f59c111d45e.jpg?v=1616755323');

      break;

    case '029292':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_00280097-8e21-4d57-abc2-7f6cd556c982.jpg?v=1616755543');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_7098b775-2d54-433a-a987-3883c3087a48.jpg?v=1616755543');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_67fc15a0-e23a-4116-9718-807c4ef62b74.jpg?v=1616755543');

      break;

    case '029293':
    case '029435':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_fbf57a72-f753-4750-93b2-7a0965f59d11.jpg?v=1616755744');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_9f9568ba-1352-4024-a890-51632dadfbc0.jpg?v=1616755744');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_884dac36-ecd8-478d-9072-253dacd604b0.jpg?v=1616755744');

      break;

    case '029157':
    case '029297':
    case '029275':
    case '029276':
    case '028014':
    case '028014B':
    case '028389':
    case '029562':
    case '029576':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_bfbee9c5-dff9-40ba-be2b-b8d907f9a7cf.jpg?v=1616756009');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_7824a4f9-49d4-4a71-9a61-47aea6077451.jpg?v=1616756009');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_62da513a-86d8-4108-b60d-02e2c4817061.jpg?v=1616756008');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_a3850df8-44db-4d5b-8ee9-9101831fec1d.jpg?v=1616756009');

      break;

    case '029290':
    case '029451':
    case '029453':
    case '027296':
    case '027309':
    case '028028':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_5a1621fe-69dc-4f0a-9624-0108610ee615.jpg?v=1616756207');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_fc7cb7e0-3846-4b00-a075-1a38f8a7212c.jpg?v=1616756207');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_c2ea056d-eb69-4f31-b58e-61d625162c48.jpg?v=1616756206');

      break;

    case '031364':
    case '031376':
    case '031377':
    case '031375':
    case '031359':
    case '031232':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_CROPPED_Tavola_disegno_1.jpg?v=1642586297');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_CROPPED_Tavola_disegno_1_copia.jpg?v=1642586297');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_CROPPED_Tavola_disegno_1_copia_2.jpg?v=1642586297');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_CROPPED_Tavola_disegno_1_copia_3.jpg?v=1642586297');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_CROPPED_Tavola_disegno_1_copia_4.jpg?v=1642586296');

      break;

    case '029150':
    case '029151':
    case '029153':
    case '029154':
    case '026779':
    case '030937':
    case '030874':
    case '030936':
    case '031212':
    case '031173':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_2bca918f-f38d-4fa5-87a1-585a4b8d57cd.jpg?v=1616756409');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_0daad244-84e1-4022-bf86-656dea861fc0.jpg?v=1616756409');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_7a7d3e51-acfc-4a24-98de-654f0b8cfe92.jpg?v=1616756409');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_b28d0785-1634-45b2-bd95-ec9d7baf8df5.jpg?v=1616756409');

      break;

    case '029298':
    case '029126':
    case '029131':
    case '029127':
    case '029128':
    case '028388':
    case '028387':
    case '029947':
    case '029952':
    case '029956':
    case '029953':
    case '029949':
    case '029579':
    case '031174':
    case '031382':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_c4953833-04b5-461a-af3a-f9986d52dd2b.jpg?v=1616756744');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_9e555860-43bf-4fb1-854a-5ded51d497fa.jpg?v=1616756744');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_b69e2d41-af1c-49d5-9f59-b3ed9e2f748b.jpg?v=1616756744');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_7ebc88f1-7af5-4867-88fa-9bcd6f507d49.jpg?v=1616756744');

      break;

    case '029289':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_06391bdd-76cf-4007-8870-f9f062e327be.jpg?v=1616756938');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_0f7150d3-00be-48cf-8cdc-6d5dcc88d847.jpg?v=1616756938');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_5c883e7b-3e8b-4464-971c-6db4d6959161.jpg?v=1616756938');

      break;

    case '029291':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_bc91c087-6889-4bbc-aa68-0deddb061e12.jpg?v=1616757065');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_707295d0-2dfc-46f0-b30a-41116b884c0b.jpg?v=1616757065');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_8ac15206-5d38-4a9c-a8fb-9ad5ff849355.jpg?v=1616757065');

      break;

    case '029145':
    case '029146':
    case '029147':
    case '029149':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_f7a73b4a-301d-40b3-ad7c-82e14eded7e6.jpg?v=1616757195');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_63def63e-f7c0-4a65-b22a-272f1807a26c.jpg?v=1616757195');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_176cba74-b5e4-4a41-8a2c-834773339c9c.jpg?v=1616757195');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_b23f4501-3d5b-4b46-b537-f8f5bcd0383c.jpg?v=1616757195');

      break;

    case '029159':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_01df01dc-6c9f-416e-9af6-f7601258fd81.jpg?v=1616757506');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_979d03ce-01fc-4398-8136-ebae0734212a.jpg?v=1616757506');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_26c83bb5-4b4c-486e-8077-35ec0bc68593.jpg?v=1616757506');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_f457332f-0f1f-4fb1-b99f-0c7971a5a52d.jpg?v=1616757506');

      break;

    case '029284':
    case '029285':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_aeb47525-3428-4290-8b8f-cfbe1c69c668.jpg?v=1616757641');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_e8523a45-d5e1-4598-842d-7f0b68a1d178.jpg?v=1616757641');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_7ad8fb01-600f-46a1-a0e2-81cd1bdc87b7.jpg?v=1616757641');

      break;

    case '029287':
    case '029288':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_26c4ca41-9008-4b08-8894-be7b5af87087.jpg?v=1616757784');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_a9ec8452-8a4f-4610-bbb3-a96fcb113ac3.jpg?v=1616757785');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_b65710c0-e064-4d47-9e6a-0a0255c86fbc.jpg?v=1616757784');

      break;

    case '029286':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_bfd2caba-7fd7-480a-b6de-ffaae2b0d050.jpg?v=1616757919');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_8d34bdb7-a952-4e0b-8e6d-82d32c3b9f25.jpg?v=1616757919');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_ec20c911-4129-414f-9254-85672528349d.jpg?v=1616757919');

      break;

    case '029310':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_d7d30e1c-b1e8-4088-a050-995275629cec.jpg?v=1616758046');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_61213a6d-beb1-40a7-a7ca-442682667e98.jpg?v=1616758046');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_a424e8f5-de03-49c9-8841-b3e9c647c128.jpg?v=1616758046');

      break;

    case '029309':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_d29a4c12-a7ba-43f5-a60b-42911885aa85.jpg?v=1616758158');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_70f893f3-291b-4f3d-b0d2-83a4b19c3536.jpg?v=1616758158');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_fd887cd7-bab5-4cd1-b23c-310d18d30108.jpg?v=1616758158');

      break;

    case '029456':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_3f2590b8-b632-46f5-9c45-a61f2aeb6bc3.jpg?v=1616758285');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_d2587611-234f-4248-aeca-ed8ea6617687.jpg?v=1616758286');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_f355db13-a85d-4223-b1f2-95dfa6a1b8f8.jpg?v=1616758285');

      break;

    case '029457':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_b0c4b1eb-d369-40e6-96c2-42ed5caf7c21.jpg?v=1616758412');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_d56ff72a-1354-4857-84c2-f77a8b39bf8d.jpg?v=1616758412');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_fbd225bc-2886-4228-bc2f-82377d3edb50.jpg?v=1616758412');

      break;

    case '029132':
    case '029944':
    case '030063':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_fe5d2901-8cd9-4518-aa84-09e9e9719156.jpg?v=1616758523');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_aff2b8e4-7ea1-4c08-9902-9218588c3856.jpg?v=1616758523');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_4055c0ef-9a88-430b-b31e-4f85031bc89d.jpg?v=1616758523');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_2211a6dd-6b42-4299-ba3c-18f731fe16cd.jpg?v=1616758523');

      break;

    case '029450':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_d996c401-3e79-44d7-9b26-dd0b3d89d4d4.jpg?v=1616758712');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_8662a8a6-8799-45da-bce1-22fe30025451.jpg?v=1616758712');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_7d555ee3-cf27-4d2c-af5b-918231836b1f.jpg?v=1616758712');

      break;

    case '029452':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_77bdf55b-b609-47ae-aad2-5a59c2da8239.jpg?v=1616758810');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_9b32bf08-b1a1-40e5-bbe6-413b4b81edd0.jpg?v=1616758809');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_1c323839-f107-4468-82a5-5e4000350f21.jpg?v=1616758810');

      break;

    case '029455':
    case '031388':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_ee20dbc8-c94c-4ce3-97e6-cf7ce2cbe2e6.jpg?v=1617115552');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_2fa61a9b-2d19-4c8c-b843-65bf9004fddd.jpg?v=1617115552');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_91d9d1b7-229e-4c89-9ef1-f76f3d3c0212.jpg?v=1617115552');

      break;

    case '029838':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/CLOCHE_Tavola_disegno_1.jpg?v=1633339856');

      break;

    case '029561':
    case '029954':
    case '031381':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_XS.jpg?v=1633354489');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_S.jpg?v=1633354489');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_M.jpg?v=1633354489');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_L.jpg?v=1633354489');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_XL.jpg?v=1633354489');

      break;


    case '030066':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANT_ATTICO_S.jpg?v=1633355133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANT_ATTICO_M.jpg?v=1633355133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANT_ATTICO_L.jpg?v=1633355133');

      break;

    case '030064':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANTALONE_CON_TASCONI_DONNA_S.jpg?v=1633355361');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANTALONE_CON_TASCONI_DONNA_M.jpg?v=1633355361');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANTALONE_CON_TASCONI_DONNA_L.jpg?v=1633355361');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANTALONE_CON_TASCONI_DONNA_XL.jpg?v=1633355361');

      break;

    case '029772':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANTALONE_CON_TASCONI_UOMO_S.jpg?v=1633355575');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANTALONE_CON_TASCONI_UOMO_M.jpg?v=1633355575');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANTALONE_CON_TASCONI_UOMO_L.jpg?v=1633355575');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/PANTALONE_CON_TASCONI_UOMO_XL.jpg?v=1633355575');

      break;

    case '029544':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029544_S.jpg?v=1634040274');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029544_M.jpg?v=1634040274');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029544_L.jpg?v=1634040274');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029544_XL.jpg?v=1634040274');

      break;

    case '029557':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029557_S.jpg?v=1634040518');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029557_M.jpg?v=1634040519');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029557_L.jpg?v=1634040519');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029557_XL.jpg?v=1634040518');

      break;

    case '030074':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/030074_S.jpg?v=1634040794');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/030074_M.jpg?v=1634040794');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/030074_L.jpg?v=1634040794');

      break;

    case '030071':
    case '031372':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_97850f01-e8b7-4b65-8101-a3a02d44f5f2.jpg?v=1637586007');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_670da504-891e-4c2d-b64f-b91cf7661757.jpg?v=1637586007');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_fae3c03e-a855-4acf-8beb-145146cfd23d.jpg?v=1637586007');

      break;

    case '031110':
    case '031234':
    case '031353':
    case '031208':
    case '031206':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_Tavola_XS.jpg?v=1639648780');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_Tavola_S.jpg?v=1639648780');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_Tavola_M.jpg?v=1639648780');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_Tavola_L.jpg?v=1639648780');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/FELPA_CAPPUCCIO_OVER_Tavola_XL.jpg?v=1639648780');

      break;

    case '031111':
    case '031235':
    case '031298':
    case '031202':
    case '031357':
    case '031354':
    case '031350':
    case '031196':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T-SHIRT_OVER_Tavola_disegno_XS.jpg?v=1639645754');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T-SHIRT_OVER_Tavola_disegno_S.jpg?v=1639645754');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T-SHIRT_OVER_Tavola_disegno_M.jpg?v=1639645754');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T-SHIRT_OVER_Tavola_disegno_L.jpg?v=1639645754');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T-SHIRT_OVER_Tavola_disegno_XL.jpg?v=1639645754');

      break;

    case '031210':
    case '031349':
    case '031167':
    case '031245':
    case '031297':
    case '031299':
    case '031248':
    case '031220':
    case '031362':
    case '031351':
    case '031175':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_Tavola_disegno_1.jpg?v=1642586357');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_Tavola_disegno_1_copia.jpg?v=1642586358');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_Tavola_disegno_1_copia_2.jpg?v=1642586357');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_Tavola_disegno_1_copia_3.jpg?v=1642586357');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_Tavola_disegno_1_copia_4.jpg?v=1642586357');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/T_SHIRT_Tavola_disegno_1_copia_5.jpg?v=1642586357');

      break;

    case '031194':
    case '029543':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031194_XS.jpg?v=1645453189');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031194_S.jpg?v=1645453189');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031194_M.jpg?v=1645453188');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031194_L.jpg?v=1645453189');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031194_XL.jpg?v=1645453189');

      break;

    case '031195':
    case '031238':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031195_XS.jpg?v=1645453676');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031195_S.jpg?v=1645453676');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031195_M.jpg?v=1645453676');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031195_L.jpg?v=1645453677');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031195_XL.jpg?v=1645453676');

      break;

    case '031198':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031198_XS.jpg?v=1645453876');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031198_S.jpg?v=1645453876');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031198_M.jpg?v=1645453877');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031198_L.jpg?v=1645453877');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031198_XL.jpg?v=1645453877');

      break;

    case '031199':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031199_XS.jpg?v=1645454147');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031199_S.jpg?v=1645454147');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031199_M.jpg?v=1645454149');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031199_L.jpg?v=1645454148');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031199_XL.jpg?v=1645454148');

      break;

    case '031217':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031217_XS.jpg?v=1645454702');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031217_S.jpg?v=1645454702');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031217_M.jpg?v=1645454702');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031217_L.jpg?v=1645454702');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031217_XL.jpg?v=1645454702');

      break;

    case '031218':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031218_XS.jpg?v=1645454923');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031218_S.jpg?v=1645454923');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031218_M.jpg?v=1645454923');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031218_L.jpg?v=1645454923');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031218_XL.jpg?v=1645454923');

      break;

    case '031344':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031344_XS.jpg?v=1645455117');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031344_S.jpg?v=1645455117');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031344_M.jpg?v=1645455117');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031344_L.jpg?v=1645455118');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031344_XL.jpg?v=1645455117');

      break;

    case '031346':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031346_XS.jpg?v=1645455414');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031346_S.jpg?v=1645455415');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031346_M.jpg?v=1645455414');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031346_L.jpg?v=1645455415');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031346_XL.jpg?v=1645455414');

      break;

    case '031361':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031361_XS.jpg?v=1645455577');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031361_S.jpg?v=1645455577');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031361_M.jpg?v=1645455578');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031361_L.jpg?v=1645455577');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031361_XL.jpg?v=1645455578');

      break;

    case '031301':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031301_XS.jpg?v=1645548495');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031301_S.jpg?v=1645548495');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031301_M.jpg?v=1645548495');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031301_L.jpg?v=1645548497');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031301_XL.jpg?v=1645548495');

      break;

    case '031355':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031355_XS.jpg?v=1645548812');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031355_S.jpg?v=1645548813');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031355_M.jpg?v=1645548813');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031355_L.jpg?v=1645548813');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031355_XL.jpg?v=1645548813');

      break;

    case '031369':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031369_XS.jpg?v=1645602233');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031369_S.jpg?v=1645602233');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031369_M.jpg?v=1645602233');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031369_L.jpg?v=1645602233');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031369_XL.jpg?v=1645602233');

      break;

    case '031373':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031373_XS.jpg?v=1645602535');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031373_S.jpg?v=1645602534');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031373_M.jpg?v=1645602535');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031373_L.jpg?v=1645602535');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031373_XL.jpg?v=1645602534');

      break;

    case '031378':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031378_XS.jpg?v=1645602831');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031378_S.jpg?v=1645602831');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031378_M.jpg?v=1645602831');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031378_L.jpg?v=1645602831');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031378_XL.jpg?v=1645602831');

      break;

    case '031300':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031300_XS_b5c2e45b-02f4-478d-a73a-574a8d6e029b.jpg?v=1645607276');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031300_S_358a344c-8bfd-4dbc-802b-469a003d8cbe.jpg?v=1645607277');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031300_M_9f1513cb-1ff4-4610-bf22-1fa9bf531583.jpg?v=1645607276');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031300_L_f2456471-f98f-4f4c-9661-91b6af6114aa.jpg?v=1645607279');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031300_XL_eb37d863-5fb8-4814-8d57-cda13850ed94.jpg?v=1645607276');

      break;

    case '031367':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031367_XS.jpg?v=1645616523');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031367_S.jpg?v=1645616523');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031367_M.jpg?v=1645616523');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031367_L.jpg?v=1645616523');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031367_XL.jpg?v=1645616523');

      break;

    case '031168':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031168_XS.jpg?v=1645795968');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031168_S.jpg?v=1645795968');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031168_M.jpg?v=1645795968');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031168_L.jpg?v=1645795969');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031168_XL.jpg?v=1645795968');

      break;

    case '031242':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031242_XS.jpg?v=1645796187');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031242_S.jpg?v=1645796187');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031242_M.jpg?v=1645796187');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031242_L.jpg?v=1645796187');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031242_XL.jpg?v=1645796187');

      break;

    case '031352':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031352_XS.jpg?v=1645796351');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031352_S.jpg?v=1645796350');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031352_M.jpg?v=1645796351');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031352_L.jpg?v=1645796351');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031352_XL.jpg?v=1645796351');

      break;

    case '031479':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031479_XS.jpg?v=1645796559');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031479_S.jpg?v=1645796558');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031479_M.jpg?v=1645796559');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031479_L.jpg?v=1645796559');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031479_XL.jpg?v=1645796559');

      break;

    case '031383':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031383_XS.jpg?v=1645862083');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031383_S.jpg?v=1645862083');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031383_M.jpg?v=1645862083');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031383_L.jpg?v=1645862083');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031383_XL.jpg?v=1645862083');

      break;

    case '029565':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029565_XS.jpg?v=1646734046');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029565_S.jpg?v=1646734046');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029565_M.jpg?v=1646734046');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029565_L.jpg?v=1646734046');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/029565_XL.jpg?v=1646734046');

      break;

    case '031233':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031233_XS.jpg?v=1646817976');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031233_S.jpg?v=1646817976');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031233_M.jpg?v=1646817976');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031233_L.jpg?v=1646817976');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031233_XL.jpg?v=1646817976');

      break;

    case '030069':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/030069_XS.jpg?v=1646819394');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/030069_S.jpg?v=1646819393');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/030069_M.jpg?v=1646819394');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/030069_L.jpg?v=1646819393');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/030069_XL.jpg?v=1646819394');

      break;

    case '031384':
    case '026676':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/BERRETTO_Tavola_disegno_1.jpg?v=1649320378');

      break;

    case '031237':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/S_d70d0071-8a7f-4898-9db2-ed682eea4ed8.jpg?v=1650635141');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/M_d48e5038-032f-42f2-b459-d8b80f47d041.jpg?v=1650635141');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/L_e19b7d05-5c5a-4852-b533-b5ff50faf4f7.jpg?v=1650635141');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/XL_d0e1734c-38ab-4766-8278-2aed5db2554d.jpg?v=1650635141');

      break;

    case '032608':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032608.jpg?v=1679567343');

      break;

    case '032837':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032837_S.jpg?v=1679493044');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032837_M.jpg?v=1679493044');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032837_L.jpg?v=1679493044');

      break;

    case '032838':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032838_S.jpg?v=1679493200');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032838_M.jpg?v=1679493200');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032838_L.jpg?v=1679493200');

      break;

    case '032859':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032859_XS.jpg?v=1679493337');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032859_S.jpg?v=1679493336');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032859_M.jpg?v=1679493336');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032859_L.jpg?v=1679493336');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032859_XL.jpg?v=1679493336');

      break;

    case '032860':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032860_XS.jpg?v=1679493537');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032860_S.jpg?v=1679493537');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032860_M.jpg?v=1679493537');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032860_L.jpg?v=1679493537');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032860_XL.jpg?v=1679493537');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032860_XXL.jpg?v=1679493537');

      break;

    case '032861':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032861_S.jpg?v=1679493669');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032861_M.jpg?v=1679493669');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/032861_L.jpg?v=1679493669');

      break;

    case '033713':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033713_XS.jpg?v=1684921984');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033713_S.jpg?v=1684921984');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033713_M.jpg?v=1684921983');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033713_L.jpg?v=1684921983');

      break;


    case '033935':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033935_XS.jpg?v=1679578541');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033935_S.jpg?v=1679578541');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033935_M.jpg?v=1679578542');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033935_L.jpg?v=1679578542');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033935_XL.jpg?v=1679578542');

      break;

    case '033936':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033936_29.jpg?v=1680101103');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033936_30.jpg?v=1680101103');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033936_31.jpg?v=1680101104');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033936_32.jpg?v=1680101102');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033936_33.jpg?v=1680101102');

      break;

    case '033939':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033939_XS.jpg?v=1678725288');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033939_S.jpg?v=1678725288');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033939_M.jpg?v=1678725288');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033939_L.jpg?v=1678725288');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033939_XL.jpg?v=1678725288');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033939_XXL.jpg?v=1678725288');

      break;

    case '033941':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033941_26.jpg?v=1680101242');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033941_27.jpg?v=1680101242');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033941_28.jpg?v=1680101242');

      break;

    case '033944':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033944_XS.jpg?v=1678725424');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033944_S.jpg?v=1678725424');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033944_M.jpg?v=1678725424');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033944_L.jpg?v=1678725424');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033944_XL.jpg?v=1678725424');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033944_XXL.jpg?v=1678725424');

      break;

    case '033945':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033945_XS.jpg?v=1678725530');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033945_S.jpg?v=1678725530');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033945_M.jpg?v=1678725530');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033945_L.jpg?v=1678725530');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033945_XL.jpg?v=1678725530');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033945_XXL.jpg?v=1678725530');

      break;

    case '033946':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033946_-_XS.png?v=1677762174');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033946_-_S.png?v=1677762173');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033946_-_M.png?v=1677762174');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033946_-_L.png?v=1677762174');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033946_-_XL.png?v=1677762174');

      break;

    case '033947':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033947_-_XS.jpg?v=1677762433');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033947_-_S.jpg?v=1677762434');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033947_-_M.jpg?v=1677762433');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033947_-_L.jpg?v=1677762434');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033947_-_XL.jpg?v=1677762433');

      break;

    case '033948':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033948_-_XS.jpg?v=1677762575');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033948_-_S.jpg?v=1677762575');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033948_-_M.jpg?v=1677762574');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033948_-_L.jpg?v=1677762575');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033948_-_XL.jpg?v=1677762575');

      break;

    case '033949':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033949_-_XS.png?v=1677762722');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033949_-_S.png?v=1677762722');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033949_-_M.png?v=1677762722');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033949_-_L.png?v=1677762721');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033949_-_XL.png?v=1677762722');

      break;

    case '033950':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033950_XS.jpg?v=1678725742');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033950_S.jpg?v=1678725742');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033950_M.jpg?v=1678725742');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033950_L.jpg?v=1678725742');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033950_XL.jpg?v=1678725742');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033950_XXL.jpg?v=1678725742');


      break;

    case '033951':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033951_XS.png?v=1678726355');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033951_S.png?v=1678726355');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033951_M.png?v=1678726355');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033951_L.png?v=1678726355');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033951_XL.png?v=1678726355');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033951_XXL.png?v=1678726355');


      break;

    case '033952':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033952_-_XS.png?v=1677762848');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033952_-_S.png?v=1677762848');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033952_-_M.png?v=1677762848');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033952_-_L.png?v=1677762848');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033952_-_XL.png?v=1677762848');

      break;

    case '033953':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033953_-_XS.png?v=1677762953');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033953_-_S.png?v=1677762953');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033953_-_M.png?v=1677762953');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033953_-_L.png?v=1677762953');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033953_-_XL.png?v=1677762953');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033953_-_XXL.png?v=1677762953');

      break;

    case '033954':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033954_-_XS.png?v=1677763353');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033954_-_S.png?v=1677763352');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033954_-_M.png?v=1677763352');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033954_-_L.png?v=1677763353');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033954_-_XS.png?v=1677763353');

      break;

    case '033956':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033956_-_XS.png?v=1677763555');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033956_-_S.png?v=1677763555');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033956_-_M.png?v=1677763555');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033956_-_L.png?v=1677763556');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033956_-_XL.png?v=1677763555');

      break;

    case '033959':
    case '034111':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033959_XS.jpg?v=1679396417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033959_S.jpg?v=1679396417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033959_M.jpg?v=1679396417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033959_L.jpg?v=1679396417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033959_XL.jpg?v=1679396417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033959_XXL.jpg?v=1679396417');

      break;

    case '033960':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033960_XS.jpg?v=1679396701');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033960_S.jpg?v=1679396701');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033960_M.jpg?v=1679396701');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033960_L.jpg?v=1679396701');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033960_XL.jpg?v=1679396701');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033960_XXL.jpg?v=1679396701');

      break;

    case '033961':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033961_XS.png?v=1678786414');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033961_S.png?v=1678786415');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033961_M.png?v=1678786415');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033961_L.png?v=1678786415');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033961_XL.png?v=1678786415');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033961_XXL.png?v=1678786415');

      break;

    case '033962':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033962_XS.jpg?v=1679396968');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033962_S.jpg?v=1679396968');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033962_M.jpg?v=1679396968');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033962_L.jpg?v=1679396968');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033962_XL.jpg?v=1679396968');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033962_XXL.jpg?v=1679396968');

      break;

    case '033963':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033963_XS.jpg?v=1679493828');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033963_S.jpg?v=1679493828');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033963_M.jpg?v=1679493828');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033963_L.jpg?v=1679493828');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033963_XL.jpg?v=1679493828');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033963_XXL.jpg?v=1679493828');

      break;

    case '033964':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033964_-_XS.png?v=1677763691');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033964_-_S.png?v=1677763692');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033964_-_M.png?v=1677763691');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033964_-_L.png?v=1677763692');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033964_-_XL.png?v=1677763691');

      break;

    case '033965':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033965_-_S.jpg?v=1677763788');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033965_-_M.jpg?v=1677763789');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033965_-_L.jpg?v=1677763788');

      break;

    case '033966':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033966_XS.jpg?v=1679584133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033966_S.jpg?v=1679584133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033966_M.jpg?v=1679584133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033966_L.jpg?v=1679584133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033966_XL.jpg?v=1679584133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033966_XXL.jpg?v=1679584133');

      break;

    case '033967':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033967_-_XS.jpg?v=1677763867');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033967_-_S.jpg?v=1677763867');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033967_-_M.jpg?v=1677763868');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033967_-_L.jpg?v=1677763867');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033967_-_XL.jpg?v=1677763867');

      break;

    case '033968':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033968_-_XS.jpg?v=1677763988');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033968_-_S.jpg?v=1677763988');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033968_-_M.jpg?v=1677763987');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033968_-_L.jpg?v=1677763988');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033968_-_XL.jpg?v=1677763988');

      break;

    case '033975':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033975_-_S.jpg?v=1677764135');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033975_-_M.jpg?v=1677764135');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033975_-_L.jpg?v=1677764135');

      break;

    case '033976':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033976_S.jpg?v=1679584322');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033976_M.jpg?v=1679584322');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033976_L.jpg?v=1679584322');

      break;


    case '033977':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033977_S.jpg?v=1679585187');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033977_M.jpg?v=1679585187');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033977_L.jpg?v=1679585187');

      break;

    case '033978':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033978_S.jpg?v=1679585364');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033978_M.jpg?v=1679585364');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033978_L.jpg?v=1679585364');

      break;


    case '033979':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033979_-_XS.jpg?v=1677764987');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033979_-_S.jpg?v=1677764987');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033979_-_M.jpg?v=1677764987');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033979_-_L.jpg?v=1677764987');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033979_-_XL.jpg?v=1677764987');

      break;

    case '033980':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033980_-_S.jpg?v=1677765086');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033980_-_M.jpg?v=1677765086');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033980_-_L.jpg?v=1677765086');

      break;

    case '033981':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033981_-_S.jpg?v=1677765162');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033981_-_M.jpg?v=1677765162');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033981_-_L.jpg?v=1677765162');

      break;

    case '033985':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033985.jpg?v=1679578741');

      break;

    case '033990':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/033990.jpg?v=1678786912');

      break;

    case '034037':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034037_XS.jpg?v=1678787053');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034037_S.jpg?v=1678787054');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034037_M.jpg?v=1678787053');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034037_L.jpg?v=1678787053');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034037_XL.jpg?v=1678787053');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034037_XXL.jpg?v=1678787053');

      break;

    case '034039':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034039_XS.jpg?v=1679397133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034039_S.jpg?v=1679397132');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034039_M.jpg?v=1679397132');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034039_L.jpg?v=1679397132');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034039_XL.jpg?v=1679397132');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034039_XXL.jpg?v=1679397133');

      break;


    case '034042':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034042_XS.jpg?v=1678787417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034042_S.jpg?v=1678787416');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034042_M.jpg?v=1678787417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034042_L.jpg?v=1678787417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034042_XL.jpg?v=1678787417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034042_XXL.jpg?v=1678787417');

      break;

    case '034043':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034043_XS.jpg?v=1678787608');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034043_S.jpg?v=1678787608');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034043_M.jpg?v=1678787608');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034043_L.jpg?v=1678787609');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034043_XL.jpg?v=1678787608');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034043_XXL.jpg?v=1678787609');

      break;

    case '034044':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034044_XS.jpg?v=1678787815');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034044_S.jpg?v=1678787815');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034044_M.jpg?v=1678787815');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034044_L.jpg?v=1678787815');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034044_XL.jpg?v=1678787815');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034044_XXL.jpg?v=1678787815');

      break;

    case '034048':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034048_XS.jpg?v=1679493974');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034048_S.jpg?v=1679493974');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034048_M.jpg?v=1679493974');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034048_L.jpg?v=1679493974');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034048_XL.jpg?v=1679493974');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034048_XXL.jpg?v=1679493974');

      break;

    case '034050':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034050_XS.png?v=1679494171');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034050_S.png?v=1679494171');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034050_M.png?v=1679494171');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034050_L.png?v=1679494171');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034050_XL.png?v=1679494171');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034050_XXL.png?v=1679494171');

      break;

    case '034051':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034051_XS.jpg?v=1679494314');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034051_S.jpg?v=1679494314');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034051_M.jpg?v=1679494314');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034051_L.jpg?v=1679494314');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034051_XL.jpg?v=1679494314');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034051_XXL.jpg?v=1679494314');

      break;

    case '034052':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034052_XS.png?v=1679494720');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034052_S.png?v=1679494719');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034052_M.png?v=1679494719');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034052_L.png?v=1679494720');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034052_XL.png?v=1679494719');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034052_XXL.png?v=1679494720');

      break;

    case '034055':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034055_XS.jpg?v=1679397315');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034055_S.jpg?v=1679397315');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034055_M.jpg?v=1679397315');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034055_L.jpg?v=1679397315');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034055_XL.jpg?v=1679397315');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034055_XXL.jpg?v=1679397315');

      break;

    case '034060':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034060_XS.jpg?v=1679578886');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034060_S.jpg?v=1679578886');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034060_M.jpg?v=1679578886');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034060_L.jpg?v=1679578886');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034060_XL.jpg?v=1679578886');

      break;

    case '034073':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034073_S.png?v=1678788391');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034073_M.png?v=1678788391');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034073_L.png?v=1678788391');

      break;

    case '034074':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034074_S.png?v=1678788509');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034074_M.png?v=1678788509');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034074_L.png?v=1678788509');

      break;

    case '034075':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034075_S.jpg?v=1678867836');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034075_M.jpg?v=1678867836');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034075_L.jpg?v=1678867836');

      break;

    case '034076':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034076_S.jpg?v=1678867960');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034076_M.jpg?v=1678867960');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034076_L.jpg?v=1678867960');

      break;

    case '034077':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034077_S.jpg?v=1679585545');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034077_M.jpg?v=1679585545');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034077_L.jpg?v=1679585545');

      break;

    case '034079':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034079_-_S.jpg?v=1677765232');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034079_-_M.jpg?v=1677765232');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034079_-_L.jpg?v=1677765232');

      break;

    case '034081':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034081_XS.jpg?v=1679397962');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034081_S.jpg?v=1679397962');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034081_M.jpg?v=1679397962');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034081_L.jpg?v=1679397962');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034081_XL.jpg?v=1679397962');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034081_XXL.jpg?v=1679397962');

      break;

    case '034082':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034082_XS.jpg?v=1679398138');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034082_S.jpg?v=1679398138');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034082_M.jpg?v=1679398138');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034082_L.jpg?v=1679398138');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034082_XL.jpg?v=1679398138');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034082_XXL.jpg?v=1679398138');

      break;

    case '034083':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034083_XS.jpg?v=1679398304');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034083_S.jpg?v=1679398304');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034083_M.jpg?v=1679398304');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034083_L.jpg?v=1679398304');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034083_XL.jpg?v=1679398304');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034083_XXL.jpg?v=1679398304');

      break;

    case '034084':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034084_XS.jpg?v=1678789025');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034084_S.jpg?v=1678789026');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034084_M.jpg?v=1678789025');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034084_L.jpg?v=1678789026');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034084_XL.jpg?v=1678789026');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034084_XXL.jpg?v=1678789025');

      break;

    case '034085':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034085_XS.jpg?v=1678789280');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034085_S.jpg?v=1678789279');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034085_M.jpg?v=1678789279');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034085_L.jpg?v=1678789279');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034085_XL.jpg?v=1678789280');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034085_XXL.jpg?v=1678789279');

      break;

    case '034086':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034086_XS.jpg?v=1678789424');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034086_S.jpg?v=1678789423');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034086_M.jpg?v=1678789423');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034086_L.jpg?v=1678789423');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034086_XL.jpg?v=1678789423');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034086_XXL.jpg?v=1678789423');

      break;

    case '034087':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034087_XS.jpg?v=1678789579v');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034087_S.jpg?v=1678789579');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034087_M.jpg?v=1678789579');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034087_L.jpg?v=1678789579');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034087_XL.jpg?v=1678789579');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034087_XXL.jpg?v=1678789579');

      break;

    case '034088':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034088_XS.jpg?v=1678790239');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034088_S.jpg?v=1678790239');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034088_M.jpg?v=1678790239');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034088_L.jpg?v=1678790239');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034088_XL.jpg?v=1678790239');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034088_XXL.jpg?v=1678790239');

      break;

    case '034089':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034089_XS.jpg?v=1678790682');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034089_S.jpg?v=1678790682');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034089_M.jpg?v=1678790682');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034089_L.jpg?v=1678790682');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034089_XL.jpg?v=1678790682');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034089_XXL.jpg?v=1678790682');

      break;

    case '034090':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034090_XS.jpg?v=1678790837');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034090_S.jpg?v=1678790837');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034090_M.jpg?v=1678790837');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034090_L.jpg?v=1678790837');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034090_XL.jpg?v=1678790837');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034090_XXL.jpg?v=1678790837');

      break;

    case '034091':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034091_XS.jpg?v=1679398473');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034091_S.jpg?v=1679398473');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034091_M.jpg?v=1679398473');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034091_L.jpg?v=1679398473');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034091_XL.jpg?v=1679398473');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034091_XXL.jpg?v=1679398473');

      break;

    case '034092':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034092_XS.jpg?v=1679398630');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034092_S.jpg?v=1679398630');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034092_M.jpg?v=1679398630');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034092_L.jpg?v=1679398630');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034092_XL.jpg?v=1679398631');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034092_XXL.jpg?v=1679398631');

      break;

    case '034095':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034095_XS.jpg?v=1678868121');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034095_S.jpg?v=1678868121');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034095_M.jpg?v=1678868121');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034095_L.jpg?v=1678868122');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034095_XL.jpg?v=1678868121');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034095_XXL.jpg?v=1678868121');

      break;

    case '034096':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034096_S.jpg?v=1678791051');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034096_M.jpg?v=1678791051');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034096_L.jpg?v=1678791052');

      break;

    case '034097':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034097_S.jpg?v=1678791219');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034097_M.jpg?v=1678791218');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034097_L.jpg?v=1678791219');

      break;

    case '034098':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031359_S.jpg?v=1678791322');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031359_M.jpg?v=1678791322');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/031359_L.jpg?v=1678791321');

      break;

    case '034099':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034099_S.jpg?v=1678791777');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034099_M.jpg?v=1678791777');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034099_L.jpg?v=1678791777');

      break;

    case '034100':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034100_XS.jpg?v=1679583940');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034100_S.jpg?v=1679583940');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034100_M.jpg?v=1679583940');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034100_L.jpg?v=1679583940');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034100_XL.jpg?v=1679583940');

      break;

    case '034101':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034101_XS.jpg?v=1678869555');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034101_S.jpg?v=1678869555');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034101_M.jpg?v=1678869556');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034101_L.jpg?v=1678869555');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034101_XL.jpg?v=1678869556');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034101_XXL.jpg?v=1678869555');

      break;

    case '034102':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034102_XS.jpg?v=1678869732');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034102_S.jpg?v=1678869732');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034102_M.jpg?v=1678869732');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034102_L.jpg?v=1678869732');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034102_XL.jpg?v=1678869732');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034102_XXL.jpg?v=1678869732');

      break;

    case '034103':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034103_XS.jpg?v=1678869889');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034103_S.jpg?v=1678869889');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034103_M.jpg?v=1678869889');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034103_L.jpg?v=1678869889');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034103_XL.jpg?v=1678869889');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034103_XXL.jpg?v=1678869889');

      break;

    case '034104':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034104_XS.jpg?v=1678870085');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034104_S.jpg?v=1678870085');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034104_M.jpg?v=1678870085');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034104_L.jpg?v=1678870085');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034104_XL.jpg?v=1678870085');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034104_XXL.jpg?v=1678870085');

      break;

    case '034105':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034105_XS.jpg?v=1678870260');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034105_S.jpg?v=1678870260');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034105_M.jpg?v=1678870260');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034105_L.jpg?v=1678870260');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034105_XL.jpg?v=1678870260');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034105_XXL.jpg?v=1678870260');

      break;

    case '034108':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034108_XS.jpg?v=1678870399');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034108_S.jpg?v=1678870399');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034108_M.jpg?v=1678870399');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034108_L.jpg?v=1678870399');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034108_XL.jpg?v=1678870399');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034108_XXL.jpg?v=1678870399');

      break;

    case '034109':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034109_XS.jpg?v=1678871513');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034109_S.jpg?v=1678871512');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034109_M.jpg?v=1678871513');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034109_L.jpg?v=1678871512');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034109_XL.jpg?v=1678871513');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034109_XXL.jpg?v=1678871513');

      break;

    case '034112':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034112_XS.jpg?v=1678792291');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034112_S.jpg?v=1678792291');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034112_M.jpg?v=1678792291');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034112_L.jpg?v=1678792291');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034112_XL.jpg?v=1678792291');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034112_XXL.jpg?v=1678792291');

      break;

    case '034114':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034114_XS.jpg?v=1679494878');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034114_S.jpg?v=1679494879');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034114_M.jpg?v=1679494878');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034114_L.jpg?v=1679494878');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034114_XL.jpg?v=1679494879');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034114_XXL.jpg?v=1679494878');

      break;

    case '034115':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034115_XS.png?v=1678792436');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034115_S.png?v=1678792436');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034115_M.png?v=1678792436');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034115_L.png?v=1678792436');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034115_XL.png?v=1678792436');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034115_XXL.png?v=1678792436');

      break;

    case '034116':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034116_XS.png?v=1678792601');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034116_S.png?v=1678792601');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034116_M.png?v=1678792600');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034116_L.png?v=1678792601');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034116_XL.png?v=1678792600');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034116_XXL.png?v=1678792601');

      break;

    case '034117':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034117_XS.jpg?v=1679399193');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034117_S.jpg?v=1679399193');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034117_M.jpg?v=1679399193');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034117_L.jpg?v=1679399193');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034117_XL.jpg?v=1679399193');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034117_XXL.jpg?v=1679399193');

      break;
    case '034121':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034121_XS.jpg?v=1678871665');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034121_S.jpg?v=1678871665');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034121_M.jpg?v=1678871665');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034121_L.jpg?v=1678871665');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034121_XL.jpg?v=1678871665');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034121_XXL.jpg?v=1678871665');

      break;

    case '034106':
    case '034042':
    case '034088':
    case '034087':
    case '034089':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034106_-_XS.jpg?v=1678109257');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034106_-_S.jpg?v=1678109257');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034106_-_M.jpg?v=1678109257');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034106_-_L.jpg?v=1678109257');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034106_-_XL.jpg?v=1678109257');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034106_-_XXL.jpg?v=1678109257');

      break;

    case '034107':
    case '034044':
    case '034040':
    case '034055':
    case '034037':
    case '034081':
    case '033938':
    case '034038':
    case '034082':
    case '034091':
    case '034110':
    case '034092':
    case '034083':
    case '034039':
    case '034117':
    case '034041':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034107_-_XS.jpg?v=1678109714');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034107_-_S.jpg?v=1678109714');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034107_-_M.jpg?v=1678109714');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034107_-_L.jpg?v=1678109714');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034107_-_XL.jpg?v=1678109714');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034107_-_XXL.jpg?v=1678109714');

      break;

    case '034147':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034147_XS.jpg?v=1682667909');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034147_S.jpg?v=1682667909');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034147_M.jpg?v=1682667908');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034147_L.jpg?v=1682667909');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034147_XL.jpg?v=1682667910');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034147_XXL.jpg?v=1682667909');

      break;

    case '034148':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034148_XS.jpg?v=1682668261');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034148_S.jpg?v=1682668261');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034148_M.jpg?v=1682668261');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034148_L.jpg?v=1682668261');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034148_XL.jpg?v=1682668261');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034148_XXL.jpg?v=1682668261');

      break;

    case '034149':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034149_XS.jpg?v=1682668490');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034149_S.jpg?v=1682668490');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034149_M.jpg?v=1682668490');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034149_L.jpg?v=1682668490');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034149_XL.jpg?v=1682668491');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034149_XXL.jpg?v=1682668490');

      break;

    case '034150':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034150_XS.jpg?v=1682668760');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034150_S.jpg?v=1682668760');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034150_M.jpg?v=1682668759');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034150_L.jpg?v=1682668760');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034150_XL.jpg?v=1682668760');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034150_XXL.jpg?v=1682668759');

      break;

    case '034152':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034152_XS.jpg?v=1682669032');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034152_S.jpg?v=1682669032');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034152_M.jpg?v=1682669032');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034152_L.jpg?v=1682669032');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034152_XL.jpg?v=1682669033');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034152_XXL.jpg?v=1682669032');

      break;

    case '034153':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034153_XS.jpg?v=1682669225');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034153_S.jpg?v=1682669226');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034153_M.jpg?v=1682669226');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034153_L.jpg?v=1682669226');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034153_XL.jpg?v=1682669226');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034153_XXL.jpg?v=1682669225');

      break;

    case '034154':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034154_XS.jpg?v=1682669423');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034154_S.jpg?v=1682669423');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034154_M.jpg?v=1682669423');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034154_L.jpg?v=1682669423');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034154_XL.jpg?v=1682669423');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034154_XXL.jpg?v=1682669423');

      break;

    case '034155':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034155_XS.jpg?v=1682669671');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034155_S.jpg?v=1682669671');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034155_M.jpg?v=1682669671');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034155_L.jpg?v=1682669672');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034155_XL.jpg?v=1682669671');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034155_XXL.jpg?v=1682669671');

      break;

    case '034156':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034156_XS.jpg?v=1682670339');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034156_S.jpg?v=1682670338');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034156_M.jpg?v=1682670338');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034156_L.jpg?v=1682670338');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034156_XL.jpg?v=1682670338');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034156_XXL.jpg?v=1682670339');

      break;

    case '034166':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034166_XS.jpg?v=1682672477');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034166_S.jpg?v=1682672476');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034166_M.jpg?v=1682672477');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034166_L.jpg?v=1682672476');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034166_XL.jpg?v=1682672476');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034166_XXL.jpg?v=1682672476');

      break;

    case '034170':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034170_XS.jpg?v=1682672640');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034170_S.jpg?v=1682672640');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034170_M.jpg?v=1682672640');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034170_L.jpg?v=1682672640');

      break;

    case '034176':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034176_XS.jpg?v=1682672796');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034176_S.jpg?v=1682672797');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034176_M.jpg?v=1682672796');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034176_L.jpg?v=1682672796');

      break;

    case '034177':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034177_XS.jpg?v=1682672956');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034177_S.jpg?v=1682672956');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034177_M.jpg?v=1682672956');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034177_L.jpg?v=1682672956');

      break;

    case '034188':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034188_XS.jpg?v=1682673133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034188_S.jpg?v=1682673132');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034188_M.jpg?v=1682673133');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034188_L.jpg?v=1682673132');

      break;

    case '034198':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034198_XS.jpg?v=1682673271');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034198_S.jpg?v=1682673271');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034198_M.jpg?v=1682673271');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034198_L.jpg?v=1682673271');

      break;

    case '034199':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034199_XS.jpg?v=1682673417');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034199_S.jpg?v=1682673418');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034199_M.jpg?v=1682673418');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034199_L.jpg?v=1682673417');

      break;

    case '034204':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034204_XS.jpg?v=1682673544');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034204_S.jpg?v=1682673543');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034204_M.jpg?v=1682673543');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034204_L.jpg?v=1682673543');

      break;

    case '034210':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034210_XS.jpg?v=1682673699');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034210_S.jpg?v=1682673699');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034210_M.jpg?v=1682673699');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034210_L.jpg?v=1682673699');

      break;

    case '034211':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034211_XS.jpg?v=1682673816');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034211_S.jpg?v=1682673815');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034211_M.jpg?v=1682673815');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034211_L.jpg?v=1682673815');

      break;

    case '034215':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034215_XS.jpg?v=1682673949');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034215_S.jpg?v=1682673950');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034215_M.jpg?v=1682673950');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034215_L.jpg?v=1682673949');

      break;

    case '034221':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034221_XS.jpg?v=1682674127');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034221_S.jpg?v=1682674127');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034221_M.jpg?v=1682674127');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034221_L.jpg?v=1682674127');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034221_XL.jpg?v=1682674127');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034221_XXL.jpg?v=1682674127');

      break;

    case '034222':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034222_XS.jpg?v=1682674278');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034222_S.jpg?v=1682674278');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034222_M.jpg?v=1682674278');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034222_L.jpg?v=1682674278');

      break;

    case '034224':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034224_XS.jpg?v=1682674416');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034224_S.jpg?v=1682674416');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034224_M.jpg?v=1682674416');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034224_L.jpg?v=1682674416');

      break;

    case '034231':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034231_XS.jpg?v=1682674619');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034231_S.jpg?v=1682674619');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034231_M.jpg?v=1682674620');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034231_L.jpg?v=1682674620');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034231_XL.jpg?v=1682674619');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/034231_XXL.jpg?v=1682674619');

      break;

    case '030065':
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/GONNELLONE_Tavola_disegno_S.jpg?v=1633332326');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/GONNELLONE_Tavola_disegno_M.jpg?v=1633332327');
      images.push('https://cdn.shopify.com/s/files/1/0551/4012/2809/files/GONNELLONE_Tavola_disegno_L.jpg?v=1633332327');
  }


  let code = '';
  $.each(images, function (index, value) {
    code += '<div class=""><img src="' + value + '"></div>';
  });

  if (code !== '') {
    $('.barrow-size-guide').append(code);

    $('.barrow-size-guide').slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: 'linear'
    });
  } else {
    //$('.product-information-buttons').hide();
  }


})
;



class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('ul'),
    };
    //this.elements.button.addEventListener('click', this.openSelector.bind(this));
    //this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    //this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    ////this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    ////this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  closeSelector(event) {
    /*const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }*/
  }
}
customElements.define('localization-form', LocalizationForm);
